'use client';

import classnames from 'classnames';
import { useState } from 'react';

import styles from 'molecules/Form/selectinput/selectinput.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { ChangeEvent, FC } from 'react';

interface Option {
  abbreviation?: string;
  name?: string;
}

interface SelectInputProps {
  formStateProps?: {
    checked?: boolean;
    multiple?: boolean;
    name?: string;
    onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
    onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
    value?: string;
  };
  options: Option[];
  required?: boolean;
  id: string;
  label: string;
  message?: string;
  valid?: boolean;
  className?: string;
  validate?: (fieldName: string, value: string, required: boolean) => void;
  validateOnBlur?: (fieldName: string, value: string, required: boolean) => void;
  validateOnChange?: (fieldName: string, value: string, required: boolean) => void;
}

const SelectInput: FC<SelectInputProps> = ({
  className,
  formStateProps = {},
  options,
  required = false,
  id,
  label,
  message = 'This field is required.',
  valid = true,
  // validate,
  validateOnBlur,
  validateOnChange,
}) => {
  const [value, setValue] = useState<string>(formStateProps.value || '');

  const handleBlur = () => {
    validateOnBlur?.(id, value, required);
    {
      validateOnBlur && validateOnBlur(id, value, required);
    }
  };

  const wrapperClass = classnames(styles.wrapper, {
    [styles.floated]: value,
    [styles.error]: !valid,
    [styles.required]: required,
    [className || '']: className,
  });

  const labelClass = classnames(styles.label, {
    [styles.hidden]: value,
  });

  const { onChange: outerOnChange, ...passFormStateProps } = formStateProps;

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    validateOnChange?.(id, newValue, required);
    setValue(newValue);
    if (outerOnChange) {
      outerOnChange(e);
    }
  };

  return (
    <div className={wrapperClass}>
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <select
        {...passFormStateProps}
        id={id}
        className={styles.select}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-required={required}
        aria-describedby={!valid ? `error-${id}` : undefined}
        aria-invalid={!valid}
        aria-label={label}
      >
        <optgroup label={label}></optgroup>
        <option disabled={required} hidden={required} value="" />
        {isNonEmptyArray(options) &&
          options.map((option, index) => (
            <option className={styles.option} key={index} value={option.abbreviation}>
              {option.name}
            </option>
          ))}
      </select>
      {valid === false && message && (
        <span id={`error-${id}`} className={styles.errorMessage} aria-hidden={valid}>
          {message}
        </span>
      )}
    </div>
  );
};

export default SelectInput;
